export default __webpack_public_path__ + "static/media/step-3.ee750e6c.png";